import { render, staticRenderFns } from "./qyCustomerManage.vue?vue&type=template&id=9b82b332&scoped=true"
import script from "./qyCustomerManage.vue?vue&type=script&lang=js"
export * from "./qyCustomerManage.vue?vue&type=script&lang=js"
import style0 from "./qyCustomerManage.vue?vue&type=style&index=0&id=9b82b332&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b82b332",
  null
  
)

export default component.exports